import { Injectable, inject } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpErrorResponse, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { NotificationService } from 'src/app/shared/service/utils/notification.service';
import { BackendErrorBody, extractBackendErrorMessage } from 'src/app/shared/models/backend-error.model';

const GENERIC_ERROR_MESSAGE = 'Ocurrió un error inesperado. Intenta nuevamente.';

/**
 * Cuando el back responde con el contrato de error (`code`/`description`/`errorType`),
 * muestra `description` como toast — sin importar el status HTTP. No reemplaza el
 * manejo propio de cada vista, solo cubre el caso donde nadie más lo estaba mostrando.
 */
@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  private readonly notification = inject(NotificationService);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        const body = error.error as BackendErrorBody | null;

        if (body && typeof body === 'object' && ('description' in body || 'errorType' in body)) {
          this.notification.error(extractBackendErrorMessage(error, GENERIC_ERROR_MESSAGE));

          // Detalle técnico para soporte (traceId/componente/stack) — nunca al usuario.
          if (body.traceId || body.exceptionDetails?.length) {
            console.error('[HttpErrorInterceptor]', body.code, body.traceId, body.exceptionDetails);
          }
        }

        return throwError(() => error);
      }),
    );
  }
}
